if (!customElements.get("quantity-ui")) {
  customElements.define(
    "quantity-ui",
    class QuantityUI extends HTMLElement {
      constructor() {
        super();

        // console.log("INITQUANTITY");

        this.theInput = this.querySelector("input[name='quantity']");
        this.querySelectorAll("button").forEach((element) =>
            {
              const operation = element.dataset.op;
              if (operation === "inc") {
                element.addEventListener("click", () => {
                  this.onClickQuantity(1);
                });
              } else if (operation === "dec") {
                element.addEventListener("click", () => {
                  this.onClickQuantity(-1);
                });
              }
            }
        );

      }

      onClickQuantity(num) {
        this.theInput.stepUp(num);
      }

    }
  );
}
